import { Component, components, Entity, registerComponent, SinglePropertySchema } from "aframe";




const preparse = (def : SinglePropertySchema<any>, value : string) =>
{
	if(def.type === 'selector') return value;
	if(def.type === 'selectorAll') return value;
	if(def.parse) return def.parse(value);
	return value;
};

export function parseExtraAttributes(attributes : string[]) : { [attrName:string] : any }
{
	const result : { [attrName:string] : any } = {};

	for(let attrib of attributes)
	{
		let ix = attrib.search(/[:=]/), attrName : string = attrib, attrValue : string = '';
		if(ix >= 0)
		{
			attrName = attrib.slice(0, ix).trim()
			attrValue = attrib.slice(ix+1).trim();
		}

		let compName = attrName;
		if( (ix = attrName.indexOf('__')) >= 0 )
			compName = attrName.slice(0, ix);

		const compDesc = components[compName];
		const schema = (compDesc as any)?.schema as any;
		if(!schema)
		{
			result[attrName] = attrValue;
			continue;
		}
 
		if( (typeof schema.type === 'string') || ('default' in schema) )
		{
			result[attrName] = preparse( schema, attrValue );
		}
		else
		{
			const parsed = AFRAME.utils.styleParser.parse(attrValue) as { [key:string] : string }, generic = schema[''], value : { [key:string] : any } = {};
			for(let key in parsed)
			{
				const def = schema[key] || generic;
				value[key] = def ? preparse(def, parsed[key] ) : parsed[key];
			}
			result[attrName] = value;
		}
	}

	return result;
}

export function setExtraAttributes(item : Entity, attributes : string[])
{
	for(let attrib of attributes)
	{
		const ix = attrib.indexOf(':');
		if(ix >= 0)
			item.setAttribute(attrib.slice(0, ix).trim(), attrib.slice(ix+1).trim());
		else
			item.setAttribute(attrib, "");
	}
}


//TODO : fuse with other DataView components

interface CollectionViewData 
{
	source : Entity;
	condition : string;
	element : string;
	template : string;
	templateEntity : Entity;
	attribute : string;
	property : string;
	extraAttributes : string[];
}
interface CollectionViewComponent extends Component
{
	data : CollectionViewData;
	childAttached : EventListener;
	childDetached : EventListener;

	createItem(target : Element) : Entity;
	getItem(target : Element) : Entity | undefined;
	setItemTarget(el : Entity, target? : Element) : void;
}
registerComponent("collection-view", {
	schema : {
		source : { type : "selector" },
		condition : { type : "string" },
		template : { type : "string" }, //Not so important anymore, could be set in extraAttributes instead
		templateEntity : { type : "selector" },
		element : { type : "string", default : "a-entity" },
		attribute :  { type : "string", default : "connection" }, //Attribute that will hold the connection to the data Entity
		property :  { type : "string" }, //Attribute's property that will hold the connection to the data Entity
		extraAttributes : { type : "array", default : [] }
	},

	init(this : CollectionViewComponent)
	{
		this.childAttached = ((event : Event & { detail : { el : Entity} }) => {

			if(event.target !== this.data.source)
				return;

			const targetEl = event.detail.el;
			if(this.data.condition && !targetEl.matches(this.data.condition))
				return; //Ignore this one.
			
			const item = this.createItem(event.detail.el);

			let next : Entity | undefined = undefined;
			for(let el = targetEl.nextElementSibling; el; el = el.nextElementSibling)
			{
				if(this.data.condition && !el.matches(this.data.condition))
					continue;
				if((next = this.getItem(el as Entity)))
					break;
			}

			if(next)
				next.before(item);
			else
				this.el.append(item);

		}) as EventListener;

		this.childDetached = ((event : Event & { detail : { el : Entity} }) => {

			if(event.target !== this.data.source)
				return;

			const item = this.getItem(event.detail.el);
			if(!item) return;

			this.setItemTarget(item, undefined);
			this.el.removeChild(item);

		}) as EventListener;

	},

	createItem(this : CollectionViewComponent, target : Element)
	{
		let item : Entity;
		if(this.data.templateEntity)
		{
			item = this.data.templateEntity.cloneNode(true) as Entity;
		}
		else
		{
			item = this.el.ownerDocument.createElement(this.data.element) as Entity;
		}
		
		if(this.data.template)
			item.setAttribute("template__collection-view-item", this.data.template);

		setExtraAttributes(item, this.data.extraAttributes);
		this.setItemTarget(item, target);
		return item;
	},

	getItem(this : CollectionViewComponent, target : Element)
	{
		for(let item = this.el.firstElementChild as Entity; item; item = item.nextElementSibling as Entity)
		{
			if(!item.components) continue;
			const component = item.components[ this.data.attribute ];
			if(!(component && component.data)) continue;

			const itemTarget = this.data.property ? component.data[this.data.property] : component.data;
			if(itemTarget === target)
				return item;
		}
	},

	setItemTarget(this : CollectionViewComponent, el : Entity, target? : Element)
	{
		const value = this.data.property ? { [this.data.property] : target } : target;
		el.setAttribute(this.data.attribute, value);
	},

	update(this : CollectionViewComponent, oldData : CollectionViewData)
	{
		if(oldData && oldData.source)
		{
			oldData.source.removeEventListener("child-attached", this.childAttached);
			oldData.source.removeEventListener("child-detached", this.childDetached);

			for(let el = oldData.source.firstElementChild as Entity, next : Entity; el; el = next)
			{
				next = el.nextElementSibling as Entity;
				if(this.data.condition && !el.matches(this.data.condition))
					continue;
				if(el.components && (this.data.attribute in el.components))
				{
					this.setItemTarget(el, undefined);
					el.remove();
				}
			}
		}

		if( !this.data.source )
			return;

		for(let el = this.data.source.firstElementChild as Entity; el; el = el.nextElementSibling as Entity)
		{
			if(this.data.condition && !el.matches(this.data.condition))
				continue;

			if(el.parentEl !== this.data.source)
				continue; //Attached elsewhere

			this.el.append( this.createItem(el) );
		}

		this.data.source.addEventListener("child-attached", this.childAttached);
		this.data.source.addEventListener("child-detached", this.childDetached);

	}

	

})